import React, { useContext, useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import VariableContext from "../contexts/VariableContext";
import FetchingFreq from "../contexts/FetchingFreq";
import apiService from "../services/apiService";
import { useToast } from "../contexts/ToastContext";
import { useConfirm } from "../contexts/ConfirmContext";
import SpssPage from "./datacheck/SpssPage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as XLSX from "xlsx";
import "./styles/DataCheck.css";
import BulkPreview from "./datacheck/BulkPreview"; // or wherever you place it

import {
  faFolder,
  faFile,
  faTable,
  faChartBar,
  faArrowLeft,
  faGear,
  faDownload,
  faGauge,
  faBuilding,
  faWeightScale,
  faPeopleRoof,
  faUpload,
  faHouse,
  faLaptopFile,
  faChargingStation,
  faEdit,
  faSearch,
  faFilter,
  faSave,
  faRefresh,
  faExclamationTriangle,
  faFileExcel,
  faListAlt,
  faChevronDown,
  faCheckCircle,
  faInfoCircle,
  faChartPie,
} from "@fortawesome/free-solid-svg-icons";
import Loader from "./Loader";
import ScriptingPage from "./datacheck/ScriptingPage";
import CommonButton from "../elments/CommonButton";

import AllListsModal from "./survey-scriping/AllListsModal";

///HOOKS
import { useListProcessor } from "./hooks/useListProcessor";

function DataCheck() {
  const {
    dataGroup,
    setdataGroup,
    selectedVariables,
    banners,
    setBanners,
    setSelectedVariables,
    projectId,
    savedWeightings,
    saveCurrentWeighting,
    currentSelectedVariablesset,
    setcurrentSelectedVariablesset,
    setSavedWeightings,
    weightingStats,
    setWeightingStats,
    currentSelectedVariables,
    setCurrentSelectedVariables,
    setSelectedClient,
    setSelectedProject,
    selectedProject,
    selectedClient,
    powner,
  } = useContext(VariableContext);

  const {
    setMessage,
    setActivePage,
    handleTitleClick,
    selectedTitle,
    setSelectedTitle,
    refreshData,
    setRefreshData,
    selectedBanner,
    setselectedBanner,
    selectedWeights,
    setSelectedWeights,
    selectedVariable,
    setSelectedVariable,
    loading,
    list,
    setList,
    setLoading,
    validationData,
    setValidationData,
    handleDVValidation,
    activeTab,
    setActiveTab,
  } = useContext(FetchingFreq);

  const { toast } = useToast();
  const { confirm } = useConfirm();
  const [editedValues, setEditedValues] = useState({});
  const [showBulkPreview, setShowBulkPreview] = useState(false);
  const [bulkQuery, setBulkQuery] = useState("");
  const [showOnlyMissing, setShowOnlyMissing] = useState(false);
  const [bulkEditedData, setBulkEditedData] = useState({});

  const [commonLists, setCommonLists] = useState([]);
  const [storageWarning, setStorageWarning] = useState("");
  const [networkStatus, setNetworkStatus] = useState("online");

  // NEW STATES FOR EXPORT FEATURES
  const [selectedListIndex, setSelectedListIndex] = useState(0);
  const [selectedQuestions, setSelectedQuestions] = useState({});
  const [exportQuestionData, setExportQuestionData] = useState({});
  const [availableQuestions, setAvailableQuestions] = useState([]);
  const [showQuestionSelector, setShowQuestionSelector] = useState(false);
  const questionSelectorRef = useRef(null);

  // NEW STATES FOR IMPORT FUNCTIONALITY
  const [importFile, setImportFile] = useState(null);
  const [importPreview, setImportPreview] = useState([]);
  const [showImportModal, setShowImportModal] = useState(false);
  const [importStatus, setImportStatus] = useState("");
  const [mappedQuestions, setMappedQuestions] = useState({});

  // Add this with your other state declarations
  const [settingsSearchQuery, setSettingsSearchQuery] = useState("");
  const [filteredDataGroupKeys, setFilteredDataGroupKeys] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [activeSearchField, setActiveSearchField] = useState(null);
  const [isAllListsModalOpen, setIsAllListsModalOpen] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  // Update settingsConfig state structure
  const [settingsConfig, setSettingsConfig] = useState({
    stdDev: [],
    speederCheck: [],
    duplicatesCheck: [],
    straightLiners: {
      count: 0,
      variables: [],
    },
  });

  const {
    addAllLists,
    isProcessing,
    lastResult,
    error,
    stats,
    getSummary,
    reset,
  } = useListProcessor({
    showAlerts: true,
    onSuccess: (result) => {
      // console.log ('Processing succeeded:', result.summary);
    },
    onError: (err) => {
      console.error("Processing failed:", err);
    },
  });

  const handleListUpdate = (updatedList) => {
    setList((prevLists) => {
      const listKey = Object.keys(updatedList)[0];
      return prevLists.map((list) => {
        const currentKey = Object.keys(list)[0];
        if (currentKey === listKey || list.id === updatedList.id) {
          return updatedList;
        }
        return list;
      });
    });
  };

  const handleAddAllLists = async () => {
    try {
      const result = await addAllLists(dataGroup, list, setList);

      // Open modal after successful processing
      setIsAllListsModalOpen(true);

      return result;
    } catch (err) {
      console.error("Failed to process lists:", err);
    }
  };

  // Function to filter dataGroup keys based on search query
  const updateFilteredKeys = (query) => {
    if (!dataGroup || !query) {
      setFilteredDataGroupKeys([]);
      return;
    }

    const filtered = Object.keys(dataGroup)
      .filter(
        (key) =>
          key.toLowerCase().includes(query.toLowerCase()) ||
          (dataGroup[key]?.Qtitle &&
            dataGroup[key].Qtitle.toLowerCase().includes(query.toLowerCase()))
      )
      .slice(0, 10);

    setFilteredDataGroupKeys(filtered);
  };

  // Function to handle variable selection from search dropdown
  const handleVariableSelect = (variableKey, section, index) => {
    const updatedConfig = { ...settingsConfig };

    if (section === "stdDev") {
      const updatedStdDev = [...settingsConfig.stdDev];
      updatedStdDev[index].variable = variableKey;
      updatedConfig.stdDev = updatedStdDev;
    } else if (section === "speederCheck") {
      const updatedSpeederCheck = [...settingsConfig.speederCheck];
      updatedSpeederCheck[index].variable = variableKey;
      updatedConfig.speederCheck = updatedSpeederCheck;
    } else if (section === "duplicatesCheck") {
      const updatedDuplicatesCheck = [...settingsConfig.duplicatesCheck];
      updatedDuplicatesCheck[index].variable = variableKey;
      updatedConfig.duplicatesCheck = updatedDuplicatesCheck;
    }

    setSettingsConfig(updatedConfig);
    setShowSearchDropdown(false);
    setSettingsSearchQuery("");
    setActiveSearchField(null);
  };

  // Component for adding multiple variables with search
  const SearchableVariableInput = ({
    section,
    variables = [],
    onVariablesChange,
    placeholder = "Search and add variables...",
  }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
      if (!dataGroup || !searchQuery.trim()) {
        setSearchResults([]);
        return;
      }

      const filtered = Object.keys(dataGroup)
        .filter((key) => {
          const query = searchQuery.toLowerCase();
          const matchesKey = key.toLowerCase().includes(query);
          const matchesTitle =
            dataGroup[key]?.Qtitle?.toLowerCase().includes(query);
          return matchesKey || matchesTitle;
        })
        .slice(0, 15);

      setSearchResults(filtered);
    }, [searchQuery, dataGroup]);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setShowDropdown(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleAddVariable = (variableKey) => {
      if (!variables.includes(variableKey)) {
        onVariablesChange([...variables, variableKey]);
        setSearchQuery("");
        setShowDropdown(false);
      }
    };

    const handleRemoveVariable = (variableKey) => {
      onVariablesChange(variables.filter((v) => v !== variableKey));
    };

    const handleKeyDown = (e) => {
      if (e.key === "Enter" && searchQuery.trim() && searchResults.length > 0) {
        handleAddVariable(searchResults[0]);
      } else if (
        e.key === "Backspace" &&
        !searchQuery &&
        variables.length > 0
      ) {
        handleRemoveVariable(variables[variables.length - 1]);
      }
    };

    return (
      <div className="searchable-multi-input" ref={dropdownRef}>
        {/* Selected variables display */}
        <div className="selected-variables-container">
          {variables.map((variable) => (
            <div key={variable} className="variable-tag">
              <span className="variable-name">{variable}</span>
              {dataGroup[variable]?.Qtitle && (
                <span className="variable-title">
                  {" "}
                  - {dataGroup[variable].Qtitle}
                </span>
              )}
              <CommonButton
                title="Remove variable"
                onClick={() => handleRemoveVariable(variable)}
                variant="danger"
                size="small"
                label="×"
                className="remove-variable-btn"
              />
            </div>
          ))}
        </div>

        {/* Search input */}
        <div className="multi-search-input-wrapper">
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              if (e.target.value.trim()) {
                setShowDropdown(true);
              }
            }}
            onKeyDown={handleKeyDown}
            onFocus={() => {
              if (searchQuery.trim()) setShowDropdown(true);
            }}
            placeholder={placeholder}
            className="multi-search-input"
          />
          {searchQuery && (
            <CommonButton
              title="Clear search"
              onClick={() => {
                setSearchQuery("");
                setShowDropdown(false);
              }}
              variant="danger"
              size="small"
              label="×"
              className="clear-search-btn"
            />
          )}
        </div>

        {/* Search dropdown */}
        {showDropdown && searchResults.length > 0 && (
          <div className="multi-search-dropdown">
            <div className="dropdown-header">
              <span>Select Variables</span>
              <small>Found {searchResults.length} variables</small>
            </div>
            <div className="dropdown-list">
              {searchResults.map((key) => (
                <div
                  key={key}
                  className={`dropdown-item ${
                    variables.includes(key) ? "selected" : ""
                  }`}
                  onClick={() => handleAddVariable(key)}
                >
                  <div className="item-main">
                    <div className="item-key">{key}</div>
                    <div className="item-title">
                      {dataGroup[key]?.Qtitle || "No title"}
                    </div>
                  </div>
                  <div className="item-meta">
                    <span className="item-type">
                      {dataGroup[key]?.type || "Unknown"}
                    </span>
                    <span className="item-count">
                      {dataGroup[key]?.values?.length ||
                        dataGroup[key]?.Rows?.length ||
                        0}{" "}
                      items
                    </span>
                  </div>
                  {variables.includes(key) && (
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className="selected-icon"
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  // Render search dropdown
  const renderSearchDropdown = () => {
    if (!showSearchDropdown || !activeSearchField) return null;

    const { section, index } = activeSearchField;
    const currentValue = settingsConfig[section]?.[index]?.variable || "";

    return (
      <div className="variable-search-dropdown">
        <div className="search-dropdown-header">
          <FontAwesomeIcon icon={faSearch} />
          <input
            type="text"
            placeholder="Search variables..."
            value={settingsSearchQuery}
            onChange={(e) => {
              setSettingsSearchQuery(e.target.value);
              updateFilteredKeys(e.target.value);
            }}
            autoFocus
          />
          <CommonButton
            title="Close search"
            onClick={() => {
              setShowSearchDropdown(false);
              setActiveSearchField(null);
              setSettingsSearchQuery("");
            }}
            variant="danger"
            size="small"
            label="×"
            className="close-search-btn"
          />
        </div>

        <div className="search-dropdown-list">
          {filteredDataGroupKeys.length > 0 ? (
            filteredDataGroupKeys.map((key) => (
              <div
                key={key}
                className="search-dropdown-item"
                onClick={() => handleVariableSelect(key, section, index)}
              >
                <div className="variable-key">{key}</div>
                <div className="variable-title">
                  {dataGroup[key]?.Qtitle || "No title"}
                </div>
                <div className="variable-type">
                  {dataGroup[key]?.type || "Unknown type"}
                </div>
              </div>
            ))
          ) : (
            <div className="no-results">
              {settingsSearchQuery
                ? "No variables found"
                : "Start typing to search..."}
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderSettingsModal = () => {
    if (!showSettingsModal) return null;

    const handleVariablesChange = (section, newVariables) => {
      setSettingsConfig((prev) => ({
        ...prev,
        [section]: newVariables,
      }));
    };

    const handleStraightLinersChange = (field, value) => {
      setSettingsConfig((prev) => ({
        ...prev,
        straightLiners: {
          ...prev.straightLiners,
          [field]: value,
        },
      }));
    };

    return (
      <div className="settings-modal-overlay">
        <div className="settings-modal large-modal">
          <div className="settings-modal-header">
            <h3>Settings Configuration</h3>
            <CommonButton
              title="Close modal"
              onClick={() => setShowSettingsModal(false)}
              variant="danger"
              size="small"
              label="×"
              className="close-modal-btn"
            />
          </div>

          <div className="settings-modal-content">
            {/* Standard Deviation Section */}
            <div className="settings-section">
              <div className="section-header">
                <h4>
                  <FontAwesomeIcon icon={faChartBar} />
                  Standard Deviation Checks
                </h4>
                <div className="section-info">
                  <small>
                    Variables that will be checked for standard deviation
                    outliers
                  </small>
                </div>
              </div>

              <div className="section-description">
                <p>
                  Add variables to check for respondents with unusually high
                  standard deviation in their answers.
                </p>
              </div>

              <div className="variables-input-section">
                <label className="section-label">
                  Variables for Standard Deviation Check:
                  <span className="count-badge">
                    {settingsConfig.stdDev.length} variables
                  </span>
                </label>

                <SearchableVariableInput
                  section="stdDev"
                  variables={settingsConfig.stdDev}
                  onVariablesChange={(newVars) =>
                    handleVariablesChange("stdDev", newVars)
                  }
                  placeholder="Search variables for standard deviation check..."
                />

                <div className="section-tips">
                  <p>
                    <strong>Tip:</strong> Typically used for grid questions or
                    Likert scales
                  </p>
                </div>
              </div>
            </div>

            {/* Speeder Check Section */}
            <div className="settings-section">
              <div className="section-header">
                <h4>
                  <FontAwesomeIcon icon={faGauge} />
                  Speeder Checks
                </h4>
                <div className="section-info">
                  <small>
                    Variables to identify respondents who answered too quickly
                  </small>
                </div>
              </div>

              <div className="section-description">
                <p>
                  Add variables to check for respondents who completed sections
                  unusually fast.
                </p>
              </div>

              <div className="variables-input-section">
                <label className="section-label">
                  Variables for Speeder Check:
                  <span className="count-badge">
                    {settingsConfig.speederCheck.length} variables
                  </span>
                </label>

                <SearchableVariableInput
                  section="speederCheck"
                  variables={settingsConfig.speederCheck}
                  onVariablesChange={(newVars) =>
                    handleVariablesChange("speederCheck", newVars)
                  }
                  placeholder="Search variables for speeder check..."
                />

                <div className="section-tips">
                  <p>
                    <strong>Tip:</strong> Usually timing variables or key
                    validation questions
                  </p>
                </div>
              </div>
            </div>

            {/* Duplicates Check Section */}
            <div className="settings-section">
              <div className="section-header">
                <h4>
                  <FontAwesomeIcon icon={faFilter} />
                  Duplicates Check
                </h4>
                <div className="section-info">
                  <small>
                    Variables to identify duplicate or identical responses
                  </small>
                </div>
              </div>

              <div className="section-description">
                <p>
                  Add variables to check for identical response patterns that
                  might indicate duplicates.
                </p>
              </div>

              <div className="variables-input-section">
                <label className="section-label">
                  Variables for Duplicates Check:
                  <span className="count-badge">
                    {settingsConfig.duplicatesCheck.length} variables
                  </span>
                </label>

                <SearchableVariableInput
                  section="duplicatesCheck"
                  variables={settingsConfig.duplicatesCheck}
                  onVariablesChange={(newVars) =>
                    handleVariablesChange("duplicatesCheck", newVars)
                  }
                  placeholder="Search variables for duplicates check..."
                />

                <div className="section-tips">
                  <p>
                    <strong>Tip:</strong> Use demographic or key questions that
                    should vary between respondents
                  </p>
                </div>
              </div>
            </div>

            {/* NEW: Straight Liners Section */}
            <div className="settings-section straight-liners-section">
              <div className="section-header">
                <h4>
                  <FontAwesomeIcon icon={faWeightScale} />
                  Straight Liners Check
                </h4>
                <div className="section-info">
                  <small>
                    Identify respondents with identical responses across
                    multiple questions
                  </small>
                </div>
              </div>

              <div className="section-description">
                <p>
                  Configure settings to identify respondents who gave identical
                  answers (straight-lining) across a set of questions.
                </p>
              </div>

              <div className="straight-liners-config">
                <div className="config-row">
                  <div className="config-field">
                    <label className="config-label">
                      <FontAwesomeIcon icon={faExclamationTriangle} />
                      Straight Liners Threshold:
                    </label>
                    <div className="threshold-input">
                      <input
                        type="number"
                        min="1"
                        max="20"
                        value={settingsConfig.straightLiners.count}
                        onChange={(e) =>
                          handleStraightLinersChange(
                            "count",
                            parseInt(e.target.value) || 0
                          )
                        }
                        placeholder="Number of consecutive identical responses"
                        className="threshold-number"
                      />
                      <span className="threshold-label">
                        consecutive identical responses
                      </span>
                    </div>
                    <div className="threshold-tip">
                      <small>
                        Set how many consecutive identical responses constitute
                        straight-lining
                      </small>
                    </div>
                  </div>
                </div>

                <div className="config-row">
                  <div className="config-field">
                    <label className="config-label">
                      <FontAwesomeIcon icon={faTable} />
                      Variables to Check for Straight-Lining:
                      <span className="count-badge">
                        {settingsConfig.straightLiners.variables.length}{" "}
                        variables
                      </span>
                    </label>

                    <SearchableVariableInput
                      section="straightLinersVariables"
                      variables={settingsConfig.straightLiners.variables}
                      onVariablesChange={(newVars) =>
                        handleStraightLinersChange("variables", newVars)
                      }
                      placeholder="Search variables to check for straight-lining..."
                    />

                    <div className="variables-tip">
                      <small>
                        Select grid questions or series where straight-lining is
                        possible (e.g., matrix questions, Likert scales)
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="straight-liners-example">
                <div className="example-header">
                  <FontAwesomeIcon icon={faInfoCircle} />
                  <strong>Example:</strong>
                </div>
                <p>
                  If threshold is set to 5, a respondent giving the same answer
                  (e.g., "Strongly Agree") to 5 consecutive questions in the
                  selected variables will be flagged as a straight-liner.
                </p>
              </div>
            </div>
          </div>

          <div className="settings-summary">
            <div className="summary-header">
              <FontAwesomeIcon icon={faChartPie} />
              <span>Summary</span>
            </div>
            <div className="summary-stats">
              <div className="stat-item">
                <span className="stat-label">Standard Deviation:</span>
                <span className="stat-value">
                  {settingsConfig.stdDev.length} variables
                </span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Speeder Check:</span>
                <span className="stat-value">
                  {settingsConfig.speederCheck.length} variables
                </span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Duplicates Check:</span>
                <span className="stat-value">
                  {settingsConfig.duplicatesCheck.length} variables
                </span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Straight Liners:</span>
                <span className="stat-value">
                  {settingsConfig.straightLiners.count} threshold,{" "}
                  {settingsConfig.straightLiners.variables.length} variables
                </span>
              </div>
            </div>
          </div>

          <div className="settings-modal-actions">
            <CommonButton
              title="Cancel settings"
              onClick={() => setShowSettingsModal(false)}
              variant="danger"
              label="Cancel"
              className="btn-secondary"
            />
            <CommonButton
              title="Save settings configuration"
              onClick={handleSaveSettings}
              variant="success"
              symbol={faSave}
              label="Save Settings"
              className="btn-primary"
            />
          </div>
        </div>
      </div>
    );
  };

  const handleSaveSettings = () => {
    const configToSave = {
      stdDev: settingsConfig.stdDev,
      speederCheck: settingsConfig.speederCheck,
      duplicatesCheck: settingsConfig.duplicatesCheck,
      straightLiners: settingsConfig.straightLiners,
      timestamp: new Date().toISOString(),
      projectId: projectId,
      totalVariables: {
        stdDev: settingsConfig.stdDev.length,
        speederCheck: settingsConfig.speederCheck.length,
        duplicatesCheck: settingsConfig.duplicatesCheck.length,
        straightLiners: settingsConfig.straightLiners.variables.length,
      },
    };

    const blob = new Blob([JSON.stringify(configToSave, null, 2)], {
      type: "application/json",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `quality-settings-${projectId}-${
      new Date().toISOString().split("T")[0]
    }.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    localStorage.setItem(
      `quality_settings_${projectId}`,
      JSON.stringify(configToSave)
    );

    setShowSettingsModal(false);

    toast.success(`Settings saved! StdDev: ${settingsConfig.stdDev.length}, Speeder: ${settingsConfig.speederCheck.length}, Duplicates: ${settingsConfig.duplicatesCheck.length}, StraightLiners: ${settingsConfig.straightLiners.variables.length}`);
  };

  useEffect(() => {
    if (dataGroup) {
      setBulkEditedData(JSON.parse(JSON.stringify(dataGroup || {})));
    }
  }, [dataGroup]);

  // Update available questions when dataGroup changes
  useEffect(() => {
    if (dataGroup) {
      const filteredQuestions = Object.entries(dataGroup)
        .filter(
          ([key, question]) =>
            question.type === "Single Response" ||
            question.type === "Multiple2DGrid" ||
            question.type === "Multiple Response"
        )
        .map(([key, question]) => ({
          key,
          title: question.Qtitle || key,
          type: question.type,
          values: question.values || [],
          rows: question.Rows || [],
          cols: question.Cols || [],
        }));

      setAvailableQuestions(filteredQuestions);
    }
  }, [dataGroup]);

  // NEW: Handle file upload for importing logic
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setImportFile(file);
    setImportStatus("Processing file...");

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Parse the workbook to extract logic data
        const logicData = parseLogicExcel(workbook);
        setImportPreview(logicData);
        setShowImportModal(true);
        setImportStatus("File processed successfully!");
      } catch (error) {
        console.error("Error reading Excel file:", error);
        setImportStatus("Error reading file. Please check the format.");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const parseLogicExcel = (workbook) => {
    const logicData = [];
    const sheetNames = workbook.SheetNames.filter(
      (name) => name !== "Summary" && name.startsWith("Q")
    );

    sheetNames.forEach((sheetName) => {
      const worksheet = workbook.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      let questionKey = "";
      let listIndex = "";
      let commonQuestions = [];
      let listItems = [];
      let logicMappings = {};
      let columnHeaders = [];
      let variableName = "";

      for (let i = 0; i < data.length; i++) {
        const row = data[i];
        if (!row || row.length === 0) continue;

        if (
          i === 0 &&
          row[0] &&
          typeof row[0] === "string" &&
          row[0].includes("QUESTION:")
        ) {
          questionKey = row[0].replace("QUESTION:", "").trim();
        }

        if (i === 1 && row[0] && typeof row[0] === "string") {
          variableName = row[0].trim();
        }

        if (
          i === 3 &&
          row[0] &&
          typeof row[0] === "string" &&
          row[0].includes("List Used:")
        ) {
          const match = row[0].match(/List Used: List (\d+)/);
          if (match) listIndex = parseInt(match[1]) - 1;
        }

        if (
          i === 4 &&
          row[0] &&
          typeof row[0] === "string" &&
          row[0].includes("Common Questions:")
        ) {
          const questionsStr = row[0].replace("Common Questions:", "").trim();
          commonQuestions = questionsStr
            .split(",")
            .map((q) => q.trim())
            .filter((q) => q);
        }

        if (i >= 7 && row[0] && row[0] === "LIST ITEMS") {
          columnHeaders = [];
          for (let col = 2; col < row.length; col++) {
            if (row[col] && typeof row[col] === "string") {
              columnHeaders.push({
                title: row[col].trim(),
                index: data[8][col],
              });
            }
          }

          for (let j = i + 1; j < data.length; j++) {
            const dataRow = data[j];
            if (!dataRow || dataRow.length < 2) continue;

            const listItem = dataRow[0];
            const itemIndex = dataRow[1];

            if (!listItem) continue;

            // Collect columns with 'X' for this row
            const xColumns = [];
            for (
              let col = 2;
              col < Math.min(dataRow.length, columnHeaders.length + 2);
              col++
            ) {
              const cellValue = dataRow[col];

              if (
                cellValue &&
                typeof cellValue === "string" &&
                cellValue.trim().toUpperCase() === "X"
              ) {
                xColumns.push(columnHeaders[col - 2]);
              }
            }

            // Create logic string based on columns with 'X'
            let logic = "";
            if (xColumns.length > 0) {
              const values = xColumns
                .map((header) => {
                  return header.index;
                })
                .filter((val) => val !== "");

              if (values.length > 0) {
                const varName = variableName;

                if (values.length > 0) {
                  logic = `${questionKey}=${values.join(",")}`;
                }
              }
            }

            listItems.push({
              text: listItem,
              index: itemIndex,
              logic: logic,
            });
          }
          break;
        }
      }

      if (questionKey && listItems.length > 0) {
        logicData.push({
          sheetName,
          questionKey,
          variableName,
          listIndex,
          commonQuestions,
          listItems,
          logicMappings,
          columnHeaders,
        });
      }
    });

    return logicData;
  };

  // Map questions based on common questions list
  const mapQuestionsFromImport = () => {
    if (importPreview.length === 0) return;

    const mappings = {};

    importPreview.forEach((sheetData) => {
      sheetData.commonQuestions.forEach((questionKey) => {
        if (dataGroup[questionKey]) {
          if (!mappings[questionKey]) {
            mappings[questionKey] = [];
          }
          Object.entries(sheetData.listItems).forEach(
            ([targetValue, listIndices]) => {
              mappings[questionKey].push({
                targetValue: listIndices.text,
                logic: listIndices.logic,
                sourceQuestion: sheetData.questionKey,
                listIndices,
              });
            }
          );
        }
      });
    });

    setMappedQuestions(mappings);
    setImportStatus(
      `Mapped ${Object.keys(mappings).length} questions for logic application.`
    );
  };

  // Apply the imported logic to questions
  const applyImportedLogic = () => {
    if (Object.keys(mappedQuestions).length === 0) {
      toast.warning("No logic mappings found. Please map questions first.");
      return;
    }

    setLoading(true);

    try {
      const updatedDataGroup = JSON.parse(JSON.stringify(dataGroup));
      let totalApplied = 0;
      let totalPrefills = 0;

      // console.log ('Applying EMPLOY_STATUS logic to questions:', Object.keys(mappedQuestions));

      Object.entries(mappedQuestions).forEach(
        ([questionKey, logicMappings]) => {
          // console.log (`Processing question: ${questionKey}`);
          const question = updatedDataGroup[questionKey];
          if (!question) {
            // console.log (`Question ${questionKey} not found in dataGroup`);
            return;
          }

          // console.log (`Question type: ${question.type}, Logic mappings count:`, logicMappings.length);

          logicMappings.forEach((mapping) => {
            const {
              targetValue,
              logic,
              sourceQuestion,
              listIndices,
              rowNumber,
              hasPrefill,
            } = mapping;

            // console.log (`Applying logic for "${targetValue}" (Row ${rowNumber}):`, logic);

            // Handle EMPLOY_STATUS special logic
            if (logic) {
              // console.log ('EMPLOY_STATUS Row 1 logic - has prefill rules:', logic.prefillLogic);

              // Apply to values
              if (question.values && Array.isArray(question.values)) {
                question.values.forEach((value, index) => {
                  const matchesTarget =
                    value.title === targetValue ||
                    value.text === targetValue ||
                    String(value.index) === targetValue ||
                    (value.title && value.title.includes(targetValue));

                  if (matchesTarget) {
                    // console.log (`Found matching value for Row 1 at index ${index}:`, value.title);

                    // Apply show logic
                    value.filterLogic = logic;
                    totalApplied++;
                  }
                });
              }

              // Apply to rows for grid questions
              if (question.Rows && Array.isArray(question.Rows)) {
                question.Rows.forEach((row, index) => {
                  const matchesTarget =
                    row.title === targetValue ||
                    row.text === targetValue ||
                    String(row.index) === targetValue ||
                    (row.title && row.title.includes(targetValue));

                  if (matchesTarget) {
                    // console.log (`Found matching row for Row 1 at index ${index}:`, row.title);

                    // Apply show logic
                    row.filterLogic = logic;
                    totalApplied++;
                  }
                });
              }
            }
            // Handle regular show/hide logic
            else {
              // Apply to values
              if (question.values && Array.isArray(question.values)) {
                question.values.forEach((value, index) => {
                  const matchesTarget =
                    value.title === targetValue ||
                    value.text === targetValue ||
                    String(value.index) === targetValue ||
                    (value.title && value.title.includes(targetValue));

                  if (matchesTarget) {
                    // console.log (`Found matching value at index ${index}:`, value.title);
                    value.filterLogic = logic;
                    totalApplied++;
                    // console.log (`Applied logic to value: ${value.title} -> ${logic}`);
                  }
                });
              }

              // Apply to rows for grid questions
              if (question.Rows && Array.isArray(question.Rows)) {
                question.Rows.forEach((row, index) => {
                  const matchesTarget =
                    row.title === targetValue ||
                    row.text === targetValue ||
                    String(row.index) === targetValue ||
                    (row.title && row.title.includes(targetValue));

                  if (matchesTarget) {
                    // console.log (`Found matching row at index ${index}:`, row.title);
                    row.filterLogic = logic;
                    totalApplied++;
                    // console.log (`Applied logic to row: ${row.title} -> ${logic}`);
                  }
                });
              }

              // Apply to columns for grid questions
              if (question.Cols && Array.isArray(question.Cols)) {
                question.Cols.forEach((col, index) => {
                  const matchesTarget =
                    col.title === targetValue ||
                    col.text === targetValue ||
                    String(col.index) === targetValue ||
                    (col.title && col.title.includes(targetValue));

                  if (matchesTarget) {
                    // console.log (`Found matching column at index ${index}:`, col.title);
                    col.filterLogic = logic;
                    totalApplied++;
                    // console.log (`Applied logic to column: ${col.title} -> ${logic}`);
                  }
                });
              }
            }
          });

          // Update the question in dataGroup
          updatedDataGroup[questionKey] = question;
        }
      );

      // console.log ('Updated dataGroup with EMPLOY_STATUS logic:', updatedDataGroup);

      // Update state
      setdataGroup(updatedDataGroup);
      setBulkEditedData(updatedDataGroup);

      if (selectedTitle && updatedDataGroup[selectedTitle]) {
        // console.log ('Updating selected variable:', selectedTitle);
        setSelectedVariable(updatedDataGroup[selectedTitle]);
      }

      // Update editedValues
      const newEditedValues = { ...editedValues };
      Object.keys(mappedQuestions).forEach((questionKey) => {
        const question = updatedDataGroup[questionKey];
        if (!question) return;

        if (!newEditedValues[questionKey]) {
          newEditedValues[questionKey] = {};
        }

        // Update values
        if (question.values) {
          question.values.forEach((value, idx) => {
            if (value.filterLogic) {
              newEditedValues[questionKey][`value-${idx}`] = {
                filterLogic: value.filterLogic,
                prefillLogic: value.prefillLogic || null,
              };
            }
          });
        }

        // Update rows
        if (question.Rows) {
          question.Rows.forEach((row, idx) => {
            if (row.filterLogic) {
              newEditedValues[questionKey][`row-${idx}`] = {
                filterLogic: row.filterLogic,
                prefillLogic: row.prefillLogic || null,
              };
            }
          });
        }
      });

      setEditedValues(newEditedValues);

      const message = `✅ Successfully applied ${totalApplied} logic rules with ${totalPrefills} prefill rules!\n\nEMPLOY_STATUS Logic Applied:\n- Row 1: Show for EMPLOY_STATUS=1,2,5,6 | Prefill=3 for EMPLOY_STATUS=3 | Prefill=4 for EMPLOY_STATUS=4\n- Row 2: Show for EMPLOY_STATUS=2,3\n- Row 3: Show for EMPLOY_STATUS=2\n- Row 4: Show for EMPLOY_STATUS=1`;

      setImportStatus(message);
      toast.success(`Applied ${totalApplied} logic rules with ${totalPrefills} prefill rules`);
      setShowImportModal(false);
      setMappedQuestions({});
    } catch (error) {
      console.error("Error applying EMPLOY_STATUS logic:", error);
      setImportStatus(
        `Error applying logic: ${error.message}. Please try again.`
      );
    } finally {
      setLoading(false);
    }
  };

  // Check storage size when dataGroup changes
  useEffect(() => {
    const checkStorageSize = () => {
      if (!dataGroup) return;

      try {
        const dataString = JSON.stringify(dataGroup);
        const sizeInMB = (dataString.length * 2) / (1024 * 1024);

        if (sizeInMB > 4) {
          setStorageWarning(
            `Large dataset detected (${sizeInMB.toFixed(
              1
            )}MB). Some features may be limited.`
          );

          if (sizeInMB > 8) {
            console.warn("Dataset may exceed localStorage limits");
            const compressedData = compressDataForStorage(dataGroup);
            localStorage.setItem(
              `dataGroup_${projectId}_compressed`,
              JSON.stringify(compressedData)
            );
          }
        } else {
          setStorageWarning("");
        }
      } catch (error) {
        console.error("Storage size check error:", error);
      }
    };

    checkStorageSize();
  }, [dataGroup, projectId]);

  // Network status monitoring
  useEffect(() => {
    const handleOnline = () => setNetworkStatus("online");
    const handleOffline = () => setNetworkStatus("offline");

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // Initialize editedValues when selectedVariable changes
  useEffect(() => {
    if (selectedTitle && selectedVariable) {
      setEditedValues((prev) => ({
        ...prev,
        [selectedTitle]: prev[selectedTitle] || {},
      }));
    }
  }, [selectedTitle, selectedVariable]);

  // Check if a question has missing logics
  const isQuestionMissing = (q) => {
    const hasQLogic = !!(q?.Logic && String(q.Logic).trim());
    const hasTerm = !!(q?.termLogic && String(q.termLogic).trim());
    const childMissing =
      hasMissingIn(q?.values) ||
      hasMissingIn(q?.Rows) ||
      hasMissingIn(q?.Cols) ||
      hasMissingIn(q?.Statements);
    return !hasQLogic || !hasTerm || childMissing;
  };

  const hasMissingIn = (arr) => {
    if (!Array.isArray(arr) || arr.length === 0) return false;
    return arr.some((x) => !(x?.filterLogic && x.filterLogic.trim()));
  };

  // Get count of missing child logics
  const getMissingChildCount = (q) => {
    let count = 0;
    [q?.values, q?.Rows, q?.Cols, q?.Statements].forEach((arr) => {
      if (Array.isArray(arr)) {
        count += arr.filter((x) => !x?.filterLogic?.trim()).length;
      }
    });
    return count;
  };

  const bulkQuestionList = useMemo(() => {
    const entries = Object.entries(bulkEditedData || {});
    const filtered = entries.filter(([key, v]) => {
      const text = `${key} ${v?.Qtitle || ""}`.toLowerCase();
      const matchesQuery = text.includes(bulkQuery.toLowerCase());
      const missing = isQuestionMissing(v);
      return matchesQuery && (!showOnlyMissing || missing);
    });

    return filtered.sort((a, b) => a[0].localeCompare(b[0]));
  }, [bulkEditedData, bulkQuery, showOnlyMissing]);

  const handleBulkFieldChange = (qKey, field, value) => {
    setBulkEditedData((prev) => ({
      ...prev,
      [qKey]: {
        ...prev[qKey],
        [field]: value,
      },
    }));
  };

  const handleBulkChildLogicChange = (qKey, target, index, value) => {
    setBulkEditedData((prev) => {
      const next = { ...prev };
      const q = next[qKey];
      if (!q || !Array.isArray(q[target])) return prev;

      const updatedArray = [...q[target]];
      if (updatedArray[index]) {
        updatedArray[index] = {
          ...updatedArray[index],
          filterLogic: value,
        };
        next[qKey] = {
          ...q,
          [target]: updatedArray,
        };
      }
      return next;
    });
  };

  const handleBulkSaveAll = () => {
    setdataGroup(bulkEditedData);

    const updatedEditedValues = { ...editedValues };
    Object.entries(bulkEditedData).forEach(([qKey, question]) => {
      if (!updatedEditedValues[qKey]) {
        updatedEditedValues[qKey] = {};
      }

      if (question.values) {
        question.values.forEach((value, idx) => {
          if (value.filterLogic) {
            updatedEditedValues[qKey][`value-${idx}`] = value.filterLogic;
          }
        });
      }

      if (question.Rows) {
        question.Rows.forEach((row, idx) => {
          if (row.filterLogic) {
            updatedEditedValues[qKey][`row-${idx}`] = row.filterLogic;
          }
        });
      }

      if (question.Cols) {
        question.Cols.forEach((col, idx) => {
          if (col.filterLogic) {
            updatedEditedValues[qKey][`col-${idx}`] = col.filterLogic;
          }
        });
      }

      if (question.Statements) {
        question.Statements.forEach((stmt, idx) => {
          if (stmt.filterLogic) {
            updatedEditedValues[qKey][`stmt-${idx}`] = stmt.filterLogic;
          }
        });
      }
    });

    setEditedValues(updatedEditedValues);

    if (selectedTitle && bulkEditedData[selectedTitle]) {
      setSelectedVariable(bulkEditedData[selectedTitle]);
    }

    toast.success("All logics saved successfully!");
  };

  const handleBulkExportSpssSyntax = async () => {
    try {
      setLoading(true);

      const exportData = {
        project_id: projectId,
        data_group: bulkEditedData,
        settings_config: settingsConfig,
        user: powner,
        project: JSON.stringify(selectedProject),
        client: JSON.stringify(selectedClient),

        timestamp: new Date().toISOString(),
      };

      const res = await fetch(`${apiService.baseURL}/spsssyntax`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${apiService.getToken()}` },
        body: JSON.stringify(exportData),
      });
      if (!res.ok) throw new Error("Download failed");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href = url; a.download = "spss-syntax.sps"; a.click();
      URL.revokeObjectURL(url);
      toast.success("SPSS syntax file downloaded successfully!");
    } catch (error) {
      toast.error("Error exporting SPSS syntax file");
    } finally {
      setLoading(false);
    }
  };

  const goToQuestionInDV = (qKey) => {
    const question = bulkEditedData[qKey];
    setSelectedTitle(qKey);
    setSelectedVariable(question);
    setShowBulkPreview(false);
  };

  const setFilterLogic = (newLogic) => {
    setSelectedVariable((prev) => ({ ...prev, Logic: newLogic }));
  };

  useEffect(() => {
    setActivePage("dv");
  }, []);

  const handleQuestionLogicChange = (newLogic,property='Logic') => {
    setSelectedVariable((prev) => ({ ...prev, [property]: newLogic }));
  };

  const handleSaveScriptingLogic = () => {
    if (!selectedTitle) return;

    const questionEdits = editedValues[selectedTitle] || {};
    const updatedVariable = { ...selectedVariable };

    if (updatedVariable.values) {
      updatedVariable.values = updatedVariable.values.map((value, idx) => ({
        ...value,
        filterLogic:
          questionEdits[`value-${idx}`] !== undefined
            ? questionEdits[`value-${idx}`]
            : value.filterLogic,
      }));
    }

    if (updatedVariable.Rows) {
      updatedVariable.Rows = updatedVariable.Rows.map((row, idx) => ({
        ...row,
        filterLogic:
          questionEdits[`row-${idx}`] !== undefined
            ? questionEdits[`row-${idx}`]
            : row.filterLogic,
      }));
    }

    if (updatedVariable.Cols) {
      updatedVariable.Cols = updatedVariable.Cols.map((col, idx) => ({
        ...col,
        filterLogic:
          questionEdits[`col-${idx}`] !== undefined
            ? questionEdits[`col-${idx}`]
            : col.filterLogic,
      }));
    }

    if (updatedVariable.Statements) {
      updatedVariable.Statements = updatedVariable.Statements.map(
        (stmt, idx) => ({
          ...stmt,
          filterLogic:
            questionEdits[`stmt-${idx}`] !== undefined
              ? questionEdits[`stmt-${idx}`]
              : stmt.filterLogic,
        })
      );
    }

    setdataGroup((prev) => ({
      ...prev,
      [selectedTitle]: updatedVariable,
    }));

    setSelectedVariable(updatedVariable);

    setEditedValues((prev) => {
      const { [selectedTitle]: removed, ...rest } = prev;
      return rest;
    });

    handleDVValidation(selectedTitle);
    toast.success("All settings saved successfully!");
  };

  const handleExportSpssSyntax = async (etype=1) => {
    try {
      setLoading(true);

      const exportData = {
        project_id: projectId,
        data_group: dataGroup,
        settings_config: settingsConfig,
        user: powner,
        etype:etype,
        
        project: JSON.stringify(selectedProject),
        client: JSON.stringify(selectedClient),

        timestamp: new Date().toISOString(),
      };

      const res = await fetch(`${apiService.baseURL}/spsssyntax`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${apiService.getToken()}` },
        body: JSON.stringify(exportData),
      });
      if (!res.ok) throw new Error("Download failed");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href = url; a.download = "spss-syntax.sps"; a.click();
      URL.revokeObjectURL(url);
      toast.success("SPSS syntax file downloaded successfully!");
    } catch (error) {
      toast.error("Error exporting SPSS syntax file");
    } finally {
      setLoading(false);
    }
  };

  const handleExportDimensionSyntax = async () => {
    try {
      setLoading(true);

      const exportData = {
        projectId: projectId,
        variables: selectedVariables,
        banners: banners,
        filterLogic: selectedVariable?.Logic || "",
        valueLabels: selectedVariable?.valueLabels || {},
        timestamp: new Date().toISOString(),
      };

      const res = await fetch(`${apiService.baseURL}/dimension-syntax`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${apiService.getToken()}` },
        body: JSON.stringify(exportData),
      });
      if (!res.ok) throw new Error("Download failed");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href = url; a.download = "dimension-syntax.mrs"; a.click();
      URL.revokeObjectURL(url);
      toast.success("Dimension syntax file downloaded successfully!");
    } catch (error) {
      toast.error("Error exporting Dimension syntax file");
    } finally {
      setLoading(false);
    }
  };

  // Function to go to question from common lists
  const goToQuestion = (qKey) => {
    const question = dataGroup[qKey];
    if (question) {
      setSelectedTitle(qKey);
      setSelectedVariable(question);
      setActiveTab("Scripting");
    }
  };

  // Function to handle question selection for export
  const toggleQuestionSelection = (listIndex, questionKey) => {
    setSelectedQuestions((prev) => ({
      ...prev,
      [listIndex]: {
        ...prev[listIndex],
        [questionKey]: !prev[listIndex]?.[questionKey],
      },
    }));
  };

  // Function to clear localStorage
  const clearLocalStorage = () => {
    const keysToClear = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.includes("dataGroup") || key.includes("project_")) {
        keysToClear.push(key);
      }
    }

    keysToClear.forEach((key) => {
      localStorage.removeItem(key);
      // console.log (`Cleared: ${key}`);
    });

    setStorageWarning("");
    toast.info("LocalStorage cleared. Please refresh the page.");
  };

  // Function to compress data for storage
  const compressDataForStorage = (fullData) => {
    const compressed = {};

    Object.entries(fullData).forEach(([key, question]) => {
      compressed[key] = {
        Qtitle: question.Qtitle,
        type: question.type,
        Logic: question.Logic,
        termLogic: question.termLogic,
        valuesCount: question.values?.length || 0,
        rowsCount: question.Rows?.length || 0,
        colsCount: question.Cols?.length || 0,
        statementsCount: question.Statements?.length || 0,
        isStraightLinerCheck: question.isStraightLinerCheck,
        straightLinerType: question.straightLinerType,
        straightLinerValue: question.straightLinerValue,
        isHidden: question.isHidden,
      };
    });

    return compressed;
  };

  // Function to check data size
  const checkDataSize = () => {
    if (!dataGroup) return;

    try {
      const dataString = JSON.stringify(dataGroup);
      const sizeInMB = (dataString.length * 2) / (1024 * 1024);
      toast.info(`Data size: ${sizeInMB.toFixed(2)} MB — ${Object.keys(dataGroup).length} questions`);
    } catch (error) {
      console.error("Error checking data size:", error);
    }
  };

  const getCurrentLogic = (type, index) => {
    if (!selectedTitle) return "";
    const questionEdits = editedValues[selectedTitle] || {};
    const key = `${type}-${index}`;
    return questionEdits[key] !== undefined ? questionEdits[key] : "";
  };

  if (showBulkPreview) {
    return (
      <BulkPreview
        data={bulkEditedData}
        onBack={() => setShowBulkPreview(false)}
        onSaveAll={handleBulkSaveAll}
        onExportSPSS={handleBulkExportSpssSyntax}
        loading={loading}
      />
    );
  }
const handleGenerateReport = async () => {
  try {
    setLoading(true);
    // setMessage("Generating report...");
 const payload = {
          dataGroup: dataGroup,
          //varNames: dataList[title],
          projectId: projectId,
          user: powner
        };
    const response = await fetch(`${apiService.baseURL}/api/generate-report`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
 
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `Server error ${response.status}`);
    }
 
    // Trigger browser download
    const blob = await response.blob();
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = "question_report.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
 
    // setMessage("Report downloaded successfully.");
  } catch (error) {
    console.error("Generate report error:", error);
    // setMessage(`Error generating report: ${error.message}`);
  } finally {
    setLoading(false);
  }
};
  return (
    <div className="data-check-container">
      {/* Status Bar */}
      {(storageWarning || networkStatus === "offline") && (
        <div className="status-bar">
          {networkStatus === "offline" && (
            <div className="status-warning offline">
              <FontAwesomeIcon icon={faExclamationTriangle} />
              <span>You are offline. Some features may not work.</span>
            </div>
          )}
          {storageWarning && (
            <div className="status-warning storage">
              <FontAwesomeIcon icon={faExclamationTriangle} />
              <span>{storageWarning}</span>
              <CommonButton
                title="Clear localStorage"
                onClick={clearLocalStorage}
                variant="danger"
                size="small"
                label="Clear Storage"
                className="clear-storage-btn"
              />
              <CommonButton
                title="Check data size"
                onClick={checkDataSize}
                variant="warning"
                size="small"
                label="Check Size"
                className="check-size-btn"
              />
            </div>
          )}
        </div>
      )}

      {/* Tabs */}
      <div className="tabs-container">
        {/* <CommonButton
                    title="Switch to SPSS tab"
                    onClick={() => setActiveTab('SPSS')}
                    variant="tab"
                    label="SPSS"
                    isSelected={activeTab === 'SPSS'}
                /> */}
        <CommonButton
          title="Switch to Scripting tab"
          onClick={() => setActiveTab("Scripting")}
          variant="tab"
          label="Scripting"
          isSelected={activeTab === "Scripting"}
        />

        <CommonButton
          label="All Lists"
          symbol={faListAlt}
          onClick={() => {
            handleAddAllLists();
            setTimeout(() => {
              setIsAllListsModalOpen(true);
            }, 100);
          }}
          title="Create lists and view all lists"
          variant="primary"
        />

        <AllListsModal
          isOpen={isAllListsModalOpen}
          onClose={() => setIsAllListsModalOpen(false)}
          lists={list}
          sdataGroup={dataGroup}
          onListUpdate={handleListUpdate}
        />

        <CommonButton
          title="Bulk edit all logics"
          onClick={() => setShowBulkPreview(true)}
          variant="primary"
          symbol={faEdit}
          label="Bulk Edit All Logics"
          className="bulk-edit-button"
        />

        <CommonButton
          title="Open settings configuration"
          onClick={() => setShowSettingsModal(true)}
          variant="primary"
          symbol={faGear}
          label="Settings"
          className="settings-button"
        />
        {renderSettingsModal()}

        <input
          id="logic-import-file"
          type="file"
          accept=".xlsx,.xls"
          style={{ display: "none" }}
          onChange={handleFileUpload}
        />
      </div>

      {activeTab === "SPSS" && (
        <SpssPage
          handleQuestionLogicChange={handleQuestionLogicChange}
          handleExportDimensionSyntax={handleExportDimensionSyntax}
          handleExportSpssSyntax={handleExportSpssSyntax}
          handleSaveScriptingLogic={handleSaveScriptingLogic}
        />
      )}

      {activeTab === "Scripting" && (
        <ScriptingPage
          handleQuestionLogicChange={handleQuestionLogicChange}
          getCurrentLogic={getCurrentLogic}
          setEditedValues={setEditedValues}
          handleExportDimensionSyntax={handleExportDimensionSyntax}
          handleExportSpssSyntax={handleExportSpssSyntax}
          handleSaveScriptingLogic={handleSaveScriptingLogic}
          handleGenerateReport={handleGenerateReport}
        />
      )}

      {/* Debug buttons (fixed position) */}
      <div className="debug-buttons">
        <CommonButton
          title="Check data size"
          onClick={checkDataSize}
          variant="warning"
          label="📊 Size"
          className="debug-btn"
        />
        <CommonButton
          title="Clear localStorage"
          onClick={clearLocalStorage}
          variant="danger"
          label="🗑️ Clear"
          className="debug-btn danger"
        />
      </div>

      {loading && <Loader />}
      {/* {JSON.stringify(selectedVariable)} */}
    </div>
  );
}

export default DataCheck;
